var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('main',{staticClass:"section centered-content-75 is-inline-block has-text-left"},[_c('directus-article',{attrs:{"from":"slug","getter":_vm.id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }